export enum PublicRoutes {
  DEFAULT = '/Default.aspx',
  LOGIN = '/login',
  TWO_FACTOR = '/login/two-factor',
  FORGOT_PASSWORD = '/login/forgot-password',
  RESET_PASSWORD = '/reset-password',
  SERVICE_MAINTENANCE = '/service-maintenance',
}
